<template>

  <!--  <div class="p-grid tabular-nums">-->
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">
        <Toolbar v-if="$store.getters.isModeratorOrHigher" class="p-mb-4">
          <template #start>
            <div style="font-size: 1.4em;">{{ $t('Statistics') }}</div>
          </template>
          <template #end>
            <DatesRangeCalendar :minDate="computedMinDate"
                                :max-range-days="183"
                                ref="datesRangeCalendar"
                                :disabled="dataTableIsLoading"
                                @change-dates-range="changeDatesRange"/>
          </template>
        </Toolbar>
        <Spinner v-if="isLoading"/>
        <div v-else-if="$store.getters.isAccountantOrHigher" class="p-grid" :class="{'datatable-is-loading':dataTableIsLoading}">
          <div class="p-col-12 p-mb-3">
            <StatisticsOverview :invoices="adminStatistics.invoices"
                                :consumables-stat="hasExtendedStatistics ? adminStatistics.consumablesStat : null"
                                :created-orders-count="adminStatistics.createdOrdersCount"
                                :created-offers-count="adminStatistics.createdOffersCount"
                                :new-customers-count="adminStatistics.newCustomersCount"
                                :new-vehicles-count="adminStatistics.newVehiclesCount"
                                :sales-invoice-trend="adminStatistics.salesInvoiceTrend"
                                :statistics-timezone="adminStatistics.statisticsTimezone"
                                :to-timestamp="toTimestamp"/>
          </div>
          <div class="p-col-12 p-sm-12 p-md-12 p-lg-6 p-mb-3">
            <InvoicesPanel :invoices="adminStatistics.invoices" :period-label="selectedPeriodLabel"/>
          </div>
          <div class="p-col-12 p-sm-12 p-md-12 p-lg-6 p-mb-3">
            <PaymentsPanel :payments="adminStatistics.payments" :period-label="selectedPeriodLabel"/>
          </div>

          <!--          Manager common statistics-->
          <div class="p-col-12 p-sm-12 p-md-12 p-lg-12 p-mb-3">
            <ManagerCommonPanel :managerCommonStat="adminStatistics.managerCommonStat"
                                :period-label="selectedPeriodLabel"/>
          </div>



          <!--          Masters production / payments-->
          <!--          <div class="p-col-12 p-sm-12 p-md-12 p-lg-6 p-mb-3">-->
          <!--                                    work-panel-class="p-col-12 p-sm-12 p-md-12 p-lg-6 p-mb-3"-->
          <MastersProductionPanel :mastersProduction="adminStatistics.mastersProduction"
                                  :period-label="selectedPeriodLabel"
                                  :show-financial-data="canUseTechnicianEarnings"
                                  :work-panel-class="canUseTechnicianEarnings
                                      ? 'p-col-12 p-sm-12 p-md-12 p-lg-6 p-mb-3'
                                      : 'p-col-12 p-sm-12 p-md-12 p-lg-12 p-mb-3'"
                                  payments-panel-class="p-col-12 p-sm-12 p-md-12 p-lg-6 p-mb-3"/>
          <!--            <MastersProductionPanel :dataTableIsLoading="dataTableIsLoading"-->
          <!--                                    :fromTimestamp="fromTimestamp"-->
          <!--                                    :toTimestamp="toTimestamp"/>-->
          <!--          </div>-->

          <!--          Managers sales (archived orders)-->
          <div v-if="hasExtendedStatistics"
               class="p-col-12 p-sm-12 p-md-12 p-lg-12 p-mb-3">
            <ManagerSalesPanel :dataTableIsLoading="dataTableIsLoading"
                               :period-label="selectedPeriodLabel"
                               :fromTimestamp="fromTimestamp"
                               :toTimestamp="toTimestamp"/>
          </div>


          <!--          Complaints-->
          <div v-if="hasFullStatistics"
               class="p-col-12 p-sm-12 p-md-12 p-lg-6 p-mb-3">
            <ManagerSalesPanel :isWarrantyPanel="true"
                               :period-label="selectedPeriodLabel"
                               :dataTableIsLoading="dataTableIsLoading"
                               :fromTimestamp="fromTimestamp"
                               :toTimestamp="toTimestamp"/>
          </div>

          <!--          Returns-->
          <div v-if="hasFullStatistics"
               class="p-col-12 p-sm-12 p-md-12 p-lg-6 p-mb-3">
            <ReturnsPanel :dataTableIsLoading="dataTableIsLoading"
                          :period-label="selectedPeriodLabel"
                          :fromTimestamp="fromTimestamp"
                          :toTimestamp="toTimestamp"/>
          </div>
        </div>


        <div v-else-if="$store.getters.isModerator" class="p-grid" :class="{'datatable-is-loading':dataTableIsLoading}">
          <div class="p-col-12 p-sm-12 p-md-12 p-lg-12 p-mb-3" v-if="showManagerPositions">
            <ManagerOwnSalesPanel :managerPositions="moderatorStatistics.managerPositions"
                                  :period-label="selectedPeriodLabel"/>
          </div>

          <!--          <div class="p-col-12 p-sm-12 p-md-12 p-lg-12 p-mb-3">-->
          <MastersProductionPanel :showFinancialData="false"
                                  :period-label="selectedPeriodLabel"
                                  :mastersProduction="moderatorStatistics.mastersProduction"/>
          <!--            <MastersProductionPanel :isAdmin="false"-->
          <!--                                    :dataTableIsLoading="dataTableIsLoading"-->
          <!--                                    :fromTimestamp="fromTimestamp"-->
          <!--                                    :toTimestamp="toTimestamp"/>-->
          <!--          </div>-->

        </div>
        <div v-else-if="$store.state.user" style="margin: 10vh auto;" class="p-text-center">
          <h2 class="">{{ $t('Welcome') }}, {{ $store.state.user.first_name }} {{ $store.state.user.last_name }}.</h2>
          <!--          <h5>{{ $t('This page is under construction') }}.</h5>-->
        </div>

        <div v-if="showStatisticsUpgradeNotice" class="p-mt-2 p-mb-3">
          <BillingFeatureNotice :required-plan-key="statisticsUpgradePlanKey"
                                bordered
                                :title="statisticsUpgradeTitle"
                                :description="statisticsUpgradeDescription"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httpClient from "@/services/http.services";
import formatMixins from "@/mixins/formatMixins";
import DatesRangeCalendar from "@/components/DatesRangeCalendar";
import PaymentsPanel from "@/pages/overview/components/PaymentsPanel";
import ManagerSalesPanel from "@/pages/overview/components/ManagerSalesPanel";
import MastersProductionPanel from "@/pages/overview/components/MastersProductionPanel";
import ManagerCommonPanel from "@/pages/overview/components/ManagerCommonPanel";
import InvoicesPanel from "@/pages/overview/components/InvoicesPanel";
import datatableMixins from "@/mixins/datatableMixins";
import settings from "@/settings";
import showErrorsMixins from "@/mixins/showErrorsMixins";
import ReturnsPanel from "@/pages/overview/components/ReturnsPanel";
import ManagerOwnSalesPanel from "@/pages/overview/components/ManagerOwnSalesPanel.vue";
import billingFeaturesMixins from "@/mixins/billingFeaturesMixins";
import BillingFeatureNotice from "@/components/billing/BillingFeatureNotice.vue";
import StatisticsOverview from "@/pages/overview/components/StatisticsOverview.vue";

export default {
  mixins: [ formatMixins, datatableMixins, showErrorsMixins, billingFeaturesMixins ],
  components: {
    DatesRangeCalendar,
    PaymentsPanel,
    ManagerSalesPanel,
    MastersProductionPanel,
    ManagerCommonPanel,
    InvoicesPanel,
    ManagerOwnSalesPanel,
    ReturnsPanel,
    BillingFeatureNotice,
    StatisticsOverview
  },
  data() {
    return {
      adminStatistics: {
        invoices: null,
        consumablesStat: null,
        payments: {
          card: {},
          cash: {},
          bank: {},
          total_sum: 0,
          total_count: 0,
        },
        salesInvoiceTrend: [],
        createdOrdersCount: 0,
        createdOffersCount: 0,
        newCustomersCount: 0,
        newVehiclesCount: 0,
        statisticsTimezone: '',
        orders_created: [],
        managerCommonStat: [],
        managerSales: [],
        mastersProduction: [],
      },
      moderatorStatistics: {
        managerPositions: {},
        mastersProduction: [],
      },
      calendarFrom: null,
      calendarTo: null,
    }
  },
  watch: {
    'userCanGetData'(value) {
      if (value && this.billingEntitlementsReady) this.getPageData()
    },
    billingEntitlementsReady(value) {
      if (value && this.userCanGetData) this.getPageData()
    },
  },
  mounted() {
    this.scrollToTop()
    if (settings.autoLogoutTimeout && this.$store.state.logoutTimestampIsOverdue) return false
    this.generateThisMonthRange()
    this.calendarFrom = this.formatCalendarDate(this.fromTimestamp)
    this.calendarTo = this.formatCalendarDate(this.toTimestamp)
    if (this.billingEntitlementsReady) this.getPageData()
  },
  methods: {
    formatCalendarDate(timestamp) {
      if (timestamp == null) return null
      const date = new Date(Number(timestamp) * 1000)
      if (Number.isNaN(date.getTime())) return null
      return [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'),
        String(date.getDate()).padStart(2, '0')].join('-')
    },
    getPageData() {
      if (!this.billingEntitlementsReady || !this.userCanGetData || this.fetchInFlight) return
      this.getStatistics()
    },
    changeDatesRange({ fromTimestamp, toTimestamp }, loadData = false) {
      this.fromTimestamp = fromTimestamp
      this.toTimestamp = toTimestamp
      this.calendarFrom = this.formatCalendarDate(fromTimestamp)
      this.calendarTo = this.formatCalendarDate(toTimestamp)
      if (loadData) {
        this.getStatistics()
      }
    },
    getStatistics() {
      if (!this.billingEntitlementsReady || !this.userCanGetData || this.fetchInFlight) return

      if (this.$store.getters.isAccountantOrHigher) {
        this.getAdminStatistics()
      } else if (this.$store.getters.isModerator) {
        this.getModeratorStatistics()
      } else {
        this.isLoading = false
      }

    },
    async getAdminStatistics() {
      if (!this.userCanGetData || this.fetchInFlight) return

      this.$store.commit('SET_FETCH_IN_FLIGHT', true)

      this.dataTableIsLoading = true

      const ctrl = this.setController?.('adminStatistics')
      try {
        const { status, data } = await httpClient({
          url: 'statistics/get-admin-statistics',
          method: 'post',
          data: {
            dateFrom: this.fromTimestamp,
            dateTo: this.toTimestamp,
            calendarFrom: this.calendarFrom,
            calendarTo: this.calendarTo,
          },
          signal: ctrl?.signal
        })

        if (status === 200 && data) {
          this.adminStatistics.invoices = data.invoices ?? null
          this.adminStatistics.salesInvoiceTrend = data.sales_invoice_trend || []
          this.adminStatistics.createdOrdersCount = Number(data.created_orders_count || 0)
          this.adminStatistics.createdOffersCount = Number(data.created_offers_count || 0)
          this.adminStatistics.newCustomersCount = Number(data.new_customers_count || 0)
          this.adminStatistics.newVehiclesCount = Number(data.new_vehicles_count || 0)
          this.adminStatistics.statisticsTimezone = data.statistics_timezone || ''
          this.fromTimestamp = Number(data.period_from || this.fromTimestamp)
          this.toTimestamp = Number(data.period_to || this.toTimestamp)

          this.adminStatistics.consumablesStat = data.consumables ?? null

          if (data.payments) {
            const card = data.payments.card || {}
            const cash = data.payments.cash || {}
            const bank = data.payments.bank || {}

            this.adminStatistics.payments = {
              card,
              cash,
              bank,
              total_sum: Number(card.sum || 0) + Number(cash.sum || 0) + Number(bank.sum || 0),
              total_count: Number(card.count || 0) + Number(cash.count || 0) + Number(bank.count || 0),
            }

          } else {
            this.adminStatistics.payments = null
          }

          this.adminStatistics.managerCommonStat = data.manager_common_stat || []

          this.adminStatistics.mastersProduction = data.masters_production || []
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.$store.commit('SET_FETCH_IN_FLIGHT', false)
        this.isLoading = false
        this.dataTableIsLoading = false
        if (this._abortors?.adminStatistics === ctrl) {
          this._abortors.adminStatistics = null
        }
      }
    },
    async getModeratorStatistics() {
      if (!this.$store.state.user?.id) return
      if (!this.userCanGetData || this.fetchInFlight) return

      this.$store.commit('SET_FETCH_IN_FLIGHT', true)

      this.dataTableIsLoading = true

      const ctrl = this.setController?.('moderatorStatistics')
      try {
        const { status, data } = await httpClient({
          url: 'statistics/get-moderator-statistics',
          method: 'post',
          data: {
            dateFrom: this.fromTimestamp,
            dateTo: this.toTimestamp,
            calendarFrom: this.calendarFrom,
            calendarTo: this.calendarTo,
            show_manager_positions: this.showManagerPositions,
          },
          signal: ctrl?.signal
        })

        if (status === 200 && data) {
          this.fromTimestamp = Number(data.period_from || this.fromTimestamp)
          this.toTimestamp = Number(data.period_to || this.toTimestamp)
          this.moderatorStatistics.managerPositions = data.manager_positions || {}
          this.moderatorStatistics.mastersProduction = data.masters_production || []
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.$store.commit('SET_FETCH_IN_FLIGHT', false)
        this.isLoading = false
        this.dataTableIsLoading = false
        if (this._abortors?.moderatorStatistics === ctrl) {
          this._abortors.moderatorStatistics = null
        }
      }
    },
  },
  computed: {
    selectedPeriodLabel() {
      if (!this.calendarFrom || !this.calendarTo ||
          this.fromTimestamp == null || this.toTimestamp == null) return ''
      return `${this.formatDay(this.fromTimestamp)} — ${this.formatDay(this.toTimestamp)}`
    },
    currentLocationStatsLevel() {
      return this.$store.getters['billing/plan']?.stats_level || null
    },

    hasExtendedStatistics() {
      return (
          this.billingEntitlementsReady &&
          ['extended', 'full'].includes(this.currentLocationStatsLevel)
      )
    },

    hasFullStatistics() {
      return (
          this.billingEntitlementsReady &&
          this.currentLocationStatsLevel === 'full'
      )
    },

    showManagerPositions() {
      return (
          this.hasExtendedStatistics &&
          this.$store.getters.canViewOwnSalesStatistics
      )
    },

    showStatisticsUpgradeNotice() {
      return (
          !this.isLoading &&
          this.billingEntitlementsReady &&
          this.$store.getters.isModeratorOrHigher &&
          !this.hasFullStatistics
      )
    },

    statisticsUpgradePlanKey() {
      return this.hasExtendedStatistics ? 'PRO' : 'STANDARD'
    },

    statisticsUpgradeTitle() {
      const key = this.hasExtendedStatistics
          ? 'billing.statisticsGate.fullTitle'
          : 'billing.statisticsGate.extendedTitle'

      return this.$t(key)
    },

    statisticsUpgradeDescription() {
      const key = this.hasExtendedStatistics
          ? 'billing.statisticsGate.fullDescription'
          : 'billing.statisticsGate.extendedDescription'

      return this.$t(key)
    },

    computedMinDate() {
      if (this.$store.getters.isAccountantOrHigher) {
        return null
      } else {
        let d = new Date()
        d.setMonth(d.getMonth() - 3)
        return d
      }
    },
  }
}
</script>

<style lang="scss">
.datatable-wrapper {
  overflow-y: auto;
}

.positions-table {
  border-collapse: collapse;
  width: 100%;
  text-align: left;
  tr {
    th {
      padding: 8px !important;
    }
    td {
      padding: 8px !important;
    }
  }
}

.table-opened-info__row--total {
  font-weight: 500;
  //color: red!important;
}

.no-bottom-border {
  border-bottom: none !important;
}

.statistics-panel-header {
  display: flex;
  flex: 1;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  line-height: 1.1;
}

.statistics-panel-date {
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  font-weight: 400;
  //line-height: 1;
}
</style>